export const useHighlight = (item: string, query: string) => {
    return item.replace(new RegExp(query, 'gi'), (match) => {
        return `<span class="mark h5">${match}</span>`;
    });
};
